import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-breakoutgroups-main",
    templateUrl: "./breakoutgroups.main.component.html"
})
export class BreakoutGroupsMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
